import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemCrossSmall = function IconSystemCrossSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 7 7 17M7 7l10 10"
  }));
};